import React from 'react';
import TeaserCard from '../TeaserCard/TeaserCard';
import { ProgressContainer, AboutContainer } from './Raytracer.style'
import { CenterAlignedHeading } from '../Common/Common.style'
import { Header} from '../Header/Header.style'

const RayTracer = () => (
  <div>
    <Header>CSCI-711 Raytracer</Header>
    <AboutContainer>
        <p>A Physically based raytracer being developed for the RIT's global illumination course. The purpose of this page is to track development progress.
        The source code for the rayrtacer can be found <a href="https://github.com/pulkitjuneja/">here</a></p>
      </AboutContainer>
      <ProgressContainer>
      <CenterAlignedHeading>Progress</CenterAlignedHeading>
      <div className='container'>
        <div className="row">
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 2",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/Checkpoint1.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Implemented ray sphere and ray triangle intersection"}} />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 3",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/Blinn-Phong.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Blinn-phong lighting"}} />
          </div>
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 3",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/Multiple-Lights.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Multiple lighting"}} />
          </div>
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 3",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/MultiSample.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Per pixel super sampling with simple tone mapping "}} />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 4",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/Ch4-CheckBox.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Checkerboard Texture"}} />
          </div>
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 4",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/Ch4-Checkbox-Noise.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Checkerboard with perling noise "}} />
          </div>
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 4",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/Ch4-Image-Textures.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Image Texture"}} />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 5",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/Ch5-PerfectReflection.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Perfect specular Reflections"}} />
          </div>
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 5",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/Ch5-MultipleRays.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Fuzzy diffuse and specular reflections using importance sampling"}} />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 6",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/Ch6-Transparency.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Refraction and internal reflections"}} />
          </div>
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 6",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/Ch6-AdjustedShadows.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Shadow Adjustment based on reflectivity"}} />
          </div>
        <div className="row">
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 7",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/Ch7-Reinhard-1.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Reinhard with intensity 1"}} />
          </div>
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 7",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/Ch7-Reinhard-2.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Reinhard with intensity 2"}} />
          </div>
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 7",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/Ch7-Reinhard-3.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Reinhard with intensity 3"}} />
          </div>
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 7",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/Ch7-Ward-1.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Ward with intensity 1"}} />
          </div>
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 7",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/Ch7-Ward-2.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Ward with intensity 2"}} />
          </div>
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 7",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/Ch7-Ward-3.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Ward with intensity 3"}} />
          </div>
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 7",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/AdvCh-ALM-0.65.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Adaptive Logarithmic Mapping with b = 0.65"}} />
          </div>
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 7",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/AdvCh-ALM-0.75.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Adaptive Logarithmic Mapping with b = 0.75"}} />
          </div>
          <div className="col-sm-6">
          <TeaserCard cardData={{
                title: "Checkpoint 7",
                imageURL: "https://raw.githubusercontent.com/pulkitjuneja/CSCI-711-Raytracer/master/Screenshots/AdvCh-ALM-0.85.png",
                link: "https://github.com/pulkitjuneja/CSCI-711-Raytracer",
                description: "Adaptive Logarithmic Mapping with b = 0.85"}} />
          </div>
        </div>
        </div>
      </div>
    </ProgressContainer>
  </div>
)

export default RayTracer;


// WEBPACK FOOTER //
// ./src/Raytracer/Raytracer.js